<template>
  <el-container>
    <!-- 轮播图 -->
    <div class="swiper-container swiper1">
      <div class="swiper-wrapper">
        <div class="swiper-slide">
          <img src="../assets/img/newbanner1.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="../assets/img/newbanner2.jpg" />
        </div>
        <div class="swiper-slide">
          <img src="../assets/img/newbanner3.jpg" />
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>
    <div class="divcss5">
      <br><br><br><br>
      <p>奥信汽车支持查阅4S店在售的新车、二手车、特价车相关车辆信息，对中意的车辆进行收藏、或者与</p>
      <p>销售顾问及时沟通；支持用户提交底价咨询、预约试驾、买车/卖车登记、售后服务、道路救援、洗车</p>
      <p>/验车等内容预约；支持跟踪售后服务的流程进展；支持查阅汽车相关资讯，发布汽车相关帖子等内容；</p>
       <br><br><br><br>
    </div>
  </el-container>
  
</template>


<script>
import pro1 from "../assets/img/pro1.png";
import pro2 from "../assets/img/pro2.png";
import pro3 from "../assets/img/pro3.png";
export default {
  name: "home",
  components: {},
  data() {
    return {
      dialogVisible: false,
      aboutText:
        "辽宁福保保险经纪有限公司（简称福保保险经纪）是一家以保险金融+科技服务为核心的保险经纪公司。公司于2006年在辽宁省大连注册成立，注册资本金5000万元。以股东业务起步，以个人寿险业务为核心，辅助以股东业务和为大中型法人客户提供专业的风险管理服务，涵盖的领域涉及能源、地产、物业、金融等行业；合作的保险公司涵盖财险公司、寿险公司和健康保险公司逾20家；在售产品有人寿保险、年金保险、健康险、意外险、财产险等多种产品。目前已在全国开设分支机构近20家，并将在全国32个省市自治区全部开设分支机构，服务网点遍布全国。",
      product: [
        {
          proName: "和谐倍护金生终身护理保险",
          des: "关爱倍护 福享金生",
          tag: ["保单利益明确 ", "可定向给付"],
          img: pro3
        },
        {
          proName: "和谐福家守护重大疾病保险",
          des: "终身/定期 健康守护  一生福家",
          tag: ["保障广泛", "投保灵活", "疾病豁免"],
          img: pro2
        },
        {
          proName: "和谐慧馨安少儿终身重大疾病保险（甄选版）",
          des: "关爱未成年人  呵护未来希望",
          tag: ["少儿特疾16种", "身故保障灵活"],
          img: pro1
        }
      ]
    };
  },
  computed: {},
  created() {
    window.scrollTo(0, 0);
  },
  mounted() {
    this.$nextTick(() => {
      let swiper1 = new Swiper(".swiper1", {
        pagination: ".swiper-pagination",
        paginationClickable: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        spaceBetween: 30,
        autoplay: 2500, //可选选项，自动滑动
        loop: true
      });
      let swiper2 = new Swiper(".swiper2", {
        paginationClickable: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        spaceBetween: 60,
        loop: true
      });
      let swiper3 = new Swiper(".swiper3", {
        paginationClickable: ".swiper-pagination",
        nextButton: ".swiper-button-next",
        prevButton: ".swiper-button-prev",
        spaceBetween: 50,
        loop: true
      });
    });
  },
  methods: {
    toAboutUs(Str) {
      if (Str) {
        this.$router.push({
          path: "business",
          query: { activeText: Str }
        });
      } else {
        this.$router.push("/aboutUs");
        this.$store.state.headerMenuIndex = 1;
      }
    },
    toBusiness() {
      this.$router.push("/business");
      this.$store.state.headerMenuIndex = 2;
    },
    open() {
      this.$message("产品备案中敬请期待...");
    }
  }
};
</script>
<style lang="scss" scoped>
.el-container {
  height: 100%;
  width: 100%;
  flex-wrap: wrap;
}
.swiper-container {
  width: 100%;
  height: 750px;
}
.swiper-button-next,
.swiper-button-prev {
  right: 300px;
  height: 60px;
  width: 40px;
  background-color: #000;
  opacity: 0.3;
  border-radius: 2px;
  background-image: url("../assets/img/next.png");
  background-size: 22px 36px;
  &:hover {
    background-color: $font-color-gary1;
  }
}
.swiper-button-prev {
  left: 300px;
  height: 60px;
  width: 40px;
  background-color: #000;
  opacity: 0.3;
  border-radius: 2px;
  background-image: url("../assets/img/prve.png");
  background-size: 22px 36px;
  &:hover {
    background-color: $font-color-gary1;
  }
}
/deep/ .swiper-pagination-bullet-active {
  background: #808080 !important;
}
.divcss5 {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      font-size: 18px;
  }
.swiper1 {
  .swiper-slide {
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
    }
  }
}

.box {
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
  text-align: left;
  margin: 0 10%;
  .title1 {
    margin: 50px 0 10px 0;
    font-size: $font-size-lv1;
    color: $font-color-main;
  }
  .title2 {
    margin: 0 0 20px 0;
    font-size: $font-size-lv6;
    color: $font-color-gary1;
  }
}
.box1 {
  height: 380px;
  .box1-img {
    display: flex;
    img {
      min-width: 100px;
      width: 100%;
      height: 100%;
      object-fit: cover;
      object-position: center top;
      margin-right: 44px;
      cursor: pointer;
    }
  }
}
.box2 {
  height: 600px;
  width: 100%;
  min-width: 1100px;
  box-sizing: border-box;
  text-align: left;
  margin: 0;
  margin-bottom: 65px !important;
  background-color: #f6f6f6;
  display: flex;
  img {
    min-width: 500px;
  }
  .right-box {
    min-width: 500px;
    margin: 155px 50px 0 50px;
    .text {
      margin: 0;
    }
    .about-text {
      margin: 60px 0 100px 0;
      width: 522px;
      min-width: 480px;
      line-height: 23px;
      font-size: $font-size-lv5;
      color: $font-color-black;
    }
    .btn {
      width: 120px;
      height: 40px;
      background-color: $font-color-red;
      color: #fff;
      text-align: center;
      line-height: 38px;
      cursor: pointer;
    }
  }
}
.box3 {
  height: 700px;
  margin: 0;
  background-color: #f6f6f6;
  .title1 {
    margin: 50px 15% 10px 15%;
  }
  .title2 {
    margin: 0 15% 20px 15%;
  }
  .swiper-div {
    max-width: 1320px;
    min-width: 800px;
    margin: 0px 12%;
  }
  .swiper-box {
    width: 100%;
    max-width: 1320px;
    min-width: 800px;
    height: 480px;
    margin: 0 30px;
  }
}

.swiper2 {
  width: 100%;
  max-width: 1320px;
  min-width: 800px;
  height: 480px;
  // margin: 0 10%;
  padding: 0 60px;
  .swiper-slide {
    //  width: 100%;
    // display: flex;
    // width: 1320px;
    // min-width: 1000px;
    // flex-wrap: wrap;
  }
  .bg-box {
    width: 100%;
    display: flex;
    max-width: 1320px;
    min-width: 800px;
    flex-wrap: wrap;
  }
  .flex-box {
    //     width: 100%;
    // display: flex;
    // max-width: 660px;
    // min-width: 330px;
    max-width: 660px;
    min-width: 330px;
    width: 50%;
    img {
      float: right;
      max-height: 240px;
    }
    .right-img {
      float: left;
    }
  }
  .slide-text {
    float: left;
    width: 50%;
    height: 240px;
    max-width: 330px;
    min-width: 220px;
    display: inline-block;
    background-color: #fff;
    text-align: center;
    position: relative;
    div {
      font-size: $font-size-lv3;
      color: $font-color-main;
      font-weight: 600;
      margin: 10% 0;
    }
    p {
      height: 57px;
      font-size: $font-size-lv5;
      color: $font-color-black;
      margin: 0 10%;
    }
    span {
      display: inline-block;
      width: 120px;
      height: 40px;
      margin: 9% 0px 2% 0px;
      background-color: $font-color-red;
      color: #fff;
      text-align: center;
      line-height: 38px;
      cursor: pointer;
    }
    &:before {
      display: block;
      content: "";
      border-width: 10px;
      border-style: solid;
      border-color: transparent transparent transparent #fff;
      /* 定位 */
      position: absolute;
      right: -20px;
      top: 34px;
    }
  }
  .left-div {
    &:before {
      display: block;
      content: "";
      border-width: 10px;
      border-style: solid;
      border-color: transparent #fff transparent transparent;

      /* 定位 */
      position: absolute;
      right: 100%;
      top: 34px;
    }
  }
  img {
    height: 240px;
    max-width: 330px;
    min-width: 220px;
    width: 50%;
  }
  .swiper-button-next {
    background-color: unset;
    opacity: 1;
    right: 0;
    background-image: url("../assets/img/next_gary.png");
    &:hover {
      background-color: unset;
    }
  }
  .swiper-button-prev {
    background-color: unset;
    opacity: 1;
    left: 0;
    background-image: url("../assets/img/prve_gary.png");
    &:hover {
      background-color: unset;
    }
  }
}
.box5 {
  height: 490px;
  margin: 0;
  .title1 {
    margin: 50px 15% 10px 15%;
  }
  .title2 {
    margin: 0 15% 20px 15%;
  }
  .pro-list {
    display: flex;
    justify-content: space-between;
    max-width: 1400px;
    min-width: 1000px;
    margin: 0px 12%;
    .pro-item {
      width: 32.5%;
      padding: 29px 11px 11px 24px;
      box-sizing: border-box;
      border: 1px solid #ddd;
      height: 250px;
      .bg-box {
        text-align: left;
        height: 170px;
        .pro-title {
          font-size: 24px;
        }
        .pro-des {
          font-size: 18px;
          color: #d7d7d7;
          height: 30px;
          line-height: 30px;
        }
        .pro-tag {
          .tag {
            background-color: #019844;
            color: #fff;
            border-radius: 21px;
            font-size: 12px;
            display: inline-block;
            padding: 2px 6px;
            margin-right: 5px;
          }
        }
      }
      .pro-footer {
        display: flex;
        justify-content: space-between;
        padding-top: 10px;
        .price {
          color: #e73025;
          font-size: 13px;
          span {
            font-size: 26px;
            margin-right: 2px;
          }
        }
        .goBtn {
          background-color: #e73025;
          color: #fff;
          border-radius: 5px;
          height: 30px;
          line-height: 30px;
          padding: 0 5px;
        }
      }
    }
  }
}
.box4 {
  height: 530px;
  margin: 0;
  .title1 {
    margin: 50px 15% 10px 15%;
  }
  .title2 {
    margin: 0 15% 20px 15%;
  }
  .flex-box {
    width: 100%;
    max-width: 1400px;
    min-width: 1000px;
  }
  .swiper-box {
    max-width: 1400px;
    min-width: 1000px;
    margin: 0px 12%;
  }
  .swiper-slide {
    img {
      margin: 0 13px 15px 0;
      width: 22.6%;
      height: 141px;
      object-fit: fill;
      object-position: center top;
    }
  }
}
.swiper3 {
  width: 100%;
  max-width: 1400px;
  min-width: 1000px;
  height: 310px;
  // margin: 0 10%;
  padding: 0 30px;
  .swiper-button-next {
    background-color: unset;
    opacity: 1;
    right: 0;
    background-image: url("../assets/img/next_gary.png");
    &:hover {
      background-color: unset;
    }
  }
  .swiper-button-prev {
    background-color: unset;
    opacity: 1;
    left: 0;
    background-image: url("../assets/img/prve_gary.png");
    &:hover {
      background-color: unset;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/home.vue